module.exports = __webpack_public_path__ + "img/facebook.7411b033.png";